import L from 'leaflet'
import icon from 'leaflet/dist/images/marker-icon.png'

const TEST = 0

let URL_BASE = 'https://www.inumet.gub.uy/'
const PORTAL_INUMET = URL_BASE
if (TEST) URL_BASE = 'http://localhost:3000/'
else URL_BASE = 'https://www.inumet.gub.uy/'

const URL_BASE_DATA_REPORTES = URL_BASE + (TEST ? 'data/' : 'reportes/')

const URL_BASE_IMAGENES =
    URL_BASE + (TEST ? '' : 'reportes/pages/') + 'assets/img/'

const CENTRO_URUGUAY = [-35.01667, -55]

const DEFAULT_ZOOM = 8

const MAP_LAYERS_OPACITY_DEFAULT = 0.8

// Defino el marcador por defecto para Leaflet

let DefaultIcon = L.icon({
    iconUrl: icon,
    iconAnchor: [12, 41],
    shadowUrl: 'leaflet/dist/images/marker-shadow.png',
})
L.Marker.prototype.options.icon = DefaultIcon

export default {
    TEST,
    URL_BASE,
    URL_BASE_DATA_REPORTES,
    URL_BASE_IMAGENES,
    PORTAL_INUMET,
    CENTRO_URUGUAY,
    DEFAULT_ZOOM,
    MAP_LAYERS_OPACITY_DEFAULT,
}
